'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['name', 'className']);

      var cx = (0, _classnames2.default)(name, 'icon', className);

      return _react2.default.createElement('i', _extends({
        className: cx
      }, rest));
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';

Icon.propTypes = {
  name: _propTypes2.default.string.isRequired
};

exports.default = Icon;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkljb24uanMiXSwibmFtZXMiOlsiSWNvbiIsInByb3BzIiwibmFtZSIsImNsYXNzTmFtZSIsInJlc3QiLCJjeCIsImRpc3BsYXlOYW1lIiwicHJvcFR5cGVzIiwic3RyaW5nIiwiaXNSZXF1aXJlZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7Ozs7Ozs7SUFFTUEsSTs7Ozs7Ozs7Ozs7NkJBQ0s7QUFBQSxtQkFLSCxLQUFLQyxLQUxGO0FBQUEsVUFFTEMsSUFGSyxVQUVMQSxJQUZLO0FBQUEsVUFHTEMsU0FISyxVQUdMQSxTQUhLO0FBQUEsVUFJRkMsSUFKRTs7QUFNUCxVQUFJQyxLQUFLLDBCQUNQSCxJQURPLEVBRVAsTUFGTyxFQUdQQyxTQUhPLENBQVQ7O0FBTUEsYUFDRTtBQUNFLG1CQUFXRTtBQURiLFNBRU1ELElBRk4sRUFERjtBQU1EOzs7Ozs7QUFHSEosS0FBS00sV0FBTCxHQUFtQixNQUFuQjs7QUFFQU4sS0FBS08sU0FBTCxHQUFpQjtBQUNmTCxRQUFNLG9CQUFVTSxNQUFWLENBQWlCQztBQURSLENBQWpCOztrQkFJZVQsSSIsImZpbGUiOiJJY29uLmpzIiwic291cmNlUm9vdCI6IkQ6XFxQcm9qZWN0c1xccmVhY3QtdG9jYXNcXHNyYyJ9



//////////////////
// WEBPACK FOOTER
// ../lib/Icon.js
// module id = 568
// module chunks = 0